import moment, { Duration, Moment } from 'moment'
import React from 'react'
import DurationTimer from './DurationTimer'

interface Props {
  startMoment?: Moment
  endMoment?: Moment
  onTimerEnd(): any
  isZeroMinutesVisible?: boolean
  isZeroHoursVisible?: boolean
  className?: string
}

interface State {
  duration: Duration | null
}

class TimerCountdown extends React.PureComponent<Props, State> {
  state: State = {
    duration: null,
  }

  render() {
    const { duration } = this.state
    const { isZeroMinutesVisible, isZeroHoursVisible, className } = this.props

    if (!duration) return null

    return (
      <DurationTimer
        duration={duration}
        isZeroHoursVisible={isZeroHoursVisible}
        isZeroMinutesVisible={isZeroMinutesVisible}
        className={className}
      />
    )
  }

  handleSendAgainTimeChange = (duration: Duration | null) => {
    this.setState({ duration })
  }

  handleTimerEnd = () => {
    if (this.interval) clearInterval(this.interval)
    this.props.onTimerEnd()
  }

  intervalCheck = () => {
    let { startMoment, endMoment } = this.props

    if (!startMoment && !endMoment) return null
    if (!startMoment) startMoment = moment()
    if (!endMoment) endMoment = moment()
    if (!startMoment || !startMoment.isValid()) return null
    if (!endMoment || !endMoment.isValid()) return null

    if (startMoment.isSameOrAfter(endMoment)) {
      this.handleTimerEnd()
      this.handleSendAgainTimeChange(null)
    } else {
      let duration = moment.duration(endMoment.diff(startMoment))
      this.handleSendAgainTimeChange(duration)
    }
  }

  interval

  componentDidMount() {
    this.interval = setInterval(this.intervalCheck, 500)
  }

  componentWillUnmount(): void {
    if (this.interval) clearInterval(this.interval)
  }
}

export default TimerCountdown
